<template>
  <v-container fluid class="py-0 px-2">
    <v-data-table
      :headers="headers"
      :items="tableData"
      item-key="id"
      :height="$store.state.windowSize.y - 100"
      fixed-header
      must-sort
      disable-pagination
      hide-default-footer
      class="tableCursor"
    >
      <template v-slot:item="{ item }">
        <tr>
          <td>{{ item.Name }}</td>
          <td>{{ item.ID }}</td>
          <td class="px-2 tableSelectCursor">
            <v-btn icon v-if="item.Name.startsWith($store.state.auth.settings.edPrefix)">
              <v-icon @click="((currentVS = item.Name), (dialogDeleteVirtualSerivce = true))">{{ mdiDelete }}</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-row>
      <v-col cols="3">
        <v-btn block color="colorNew" @click="dialogSettings = true">
          {{ $t('label.settings') }}
        </v-btn>
      </v-col>
      <v-col cols="3">
        <v-btn block color="colorNew" @click="virtualServicesUpdate()">
          {{ $t('btn.update') }}
        </v-btn>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogSettings" max-width="60vw">
      <v-card>
        <v-card-title class="headline colorHeadlineStandard" primary-title>
          {{ $t('label.settings') }}
          <v-spacer />
          <v-icon large @click="dialogSettings = false">{{ mdiClose }}</v-icon>
        </v-card-title>
        <v-card-text>
          <v-text-field v-model="settings.edURL" clearable label="URL" hide-details />
          <v-text-field v-model="settings.edPrefix" clearable label="Prefix" hide-details />
          <v-text-field type="password" v-model="settings.edPassword" clearable :label="$t('label.password')" hide-details />
        </v-card-text>
        <v-divider class="my-3" />
        <v-card-actions>
          <v-btn @click="uploadCertificate">{{ $t('btn.uploadCertificate') }}</v-btn>
          <v-btn @click="dialogDeleteCertificate = true" color="colorDelete">{{ $t('btn.delete') }}</v-btn>
          <v-spacer />
          <v-btn color="colorSave" @click="settingsPut()">{{ $t('btn.save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <DialogConfirmDelete
      :header="$t('label.delete')"
      :body="`${$t('msg.confirmDelete')}`"
      :openDialog.sync="dialogDeleteVirtualSerivce"
      v-on:confirm="virtualServiceDelete()"
    />
    <DialogConfirmDelete
      :header="$t('label.delete')"
      :body="`${$t('msg.deleteCertificate')}`"
      :openDialog.sync="dialogDeleteCertificate"
      v-on:confirm="deleteCertificate()"
    />
    <v-snackbar v-model="snackHandler" :timeout="2000" top color="green">{{ snackMessage }}</v-snackbar>
  </v-container>
</template>

<script lang="ts">
import Vue from 'vue';
import axios from 'axios';
import DialogConfirmDelete from '@/components/DialogConfirmDelete.vue';

import { mdiClose, mdiDelete } from '@mdi/js';

export default Vue.extend({
  name: 'SettingsEdoklady',
  components: { DialogConfirmDelete },
  data: () => ({
    tableData: [],
    dialogSettings: false,
    dialogDeleteVirtualSerivce: false,
    dialogDeleteCertificate: false,
    snackHandler: false,
    snackMessage: '',
    currentVS: '',
    settings: {
      edPassword: '',
      edPrefix: '',
      edURL: '',
    },
    mdiClose: mdiClose,
    mdiDelete: mdiDelete,
  }),
  computed: {
    headers: function () {
      return [
        { text: this.$i18n.t('label.name'), value: 'name', width: '250px' },
        { text: this.$i18n.t('label.identifier'), value: 'ID', width: '200px' },
        { sortable: false, width: '48px' },
      ];
    },
  },
  mounted() {
    this.virtualServicesGET();
    this.settingsGet();
  },
  methods: {
    virtualServicesGET() {
      axios
        .get('/api/v1/edoklady/vs')
        .then((response) => {
          this.tableData = response.data;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    settingsGet() {
      axios
        .get('/api/v1/settings') // User must have access to settings so no reason for dedicated API
        .then((response) => {
          this.settings = response.data;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    settingsPut() {
      axios
        .put('/api/v1/settings', this.settings) // User must have access to settings so no reason for dedicated API
        .then(() => {
          this.snackMessage = this.$i18n.t('msg.settingsSaved') as string;
          this.snackHandler = true;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        })
        .finally(() => {
          this.dialogSettings = false;
        });
    },
    virtualServiceDelete() {
      axios
        .delete(`/api/v1/edoklady/${this.currentVS}`)
        .then(() => {
          this.virtualServicesGET();
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    virtualServicesUpdate() {
      axios
        .get('/api/v1/edoklady/update')
        .then(() => {
          this.snackHandler = true;
          this.snackMessage = this.$i18n.t('msg.done') as string;
          this.virtualServicesGET();
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    uploadCertificate() {
      const input = document.createElement('input');
      input.type = 'file';
      input.multiple = false;
      // input.accept = 'image/png';

      input.addEventListener('change', (e: Event) => {
        const target = e.target as HTMLInputElement;
        const files = target.files;
        if (files) {
          const formData = new FormData();
          for (let i = 0; i < files.length; i++) {
            formData.append('file', files[i]);
          }
          axios
            .post('/api/v1/settings/edcertificate', formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            })
            .then(() => {
              // TODO show success message
            })
            .catch((err) => {
              this.$store.dispatch('catchErrHandler', err);
            });
        }
      });
      input.click();
    },
    deleteCertificate() {
      axios
        .delete('/api/v1/settings/edcertificate')
        .then(() => {
          console.log('Certificate deleted');
          // TODO show success message
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
  },
});
</script>
